// extracted by mini-css-extract-plugin
module.exports = {"container":"signup_container_3KXIl","box":"signup_box_1vWxc"};